export const useCheckUrl = (url) => {
    const websitePattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,6}(\/.*)?$/i;
    // Check if the website matches the pattern
    if (websitePattern.test(url)) {
        return true; // Website is valid
    } else {
        return false; // Website is invalid
    }
}